import React, { useState } from 'react';
import _ from 'lodash';
import { COMPANY_INSURANCE_MANUAL, FILE_CODE } from '../utilities/constants';
import PrintUtility from '../utilities/printUtility';
import StaticFileService from '../services/StaticFiles';
import { Information } from './modals/common';
import { messageUtility } from '../utilities/messageUtility';
import { Description } from './Description';

export const CompanyInsuranceManual = ({ layout = 'middle' }) => {
  const [visibleDownloadErrorDialog, setVisibleDownloadErrorDialog] = useState(
    false
  );

  const downloadCompanyInsuranceManual = () => {
    const fileCode = COMPANY_INSURANCE_MANUAL.fileCode;
    const fileName = COMPANY_INSURANCE_MANUAL.fileName;
    const params = { file_code: fileCode };
    PrintUtility.printOrOpenBlob(
      async () => {
        return StaticFileService.files(params).then(response => {
          if (_.includes(response.type, 'octet-stream')) {
            const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
            return new Blob([bom, response], { type: 'application/pdf' });
          } else {
            setVisibleDownloadErrorDialog(true);
            return null;
          }
        });
      },
      fileName,
      FILE_CODE.PDF,
      false
    );
  };
  return (
    <React.Fragment>
      <div
        className={`CompanyInsuranceManual__manual-download CompanyInsuranceManual__layout form-list-default__ExceptionalItems${
          layout === 'middle' ? ' CompanyInsuranceManual__layout--middle' : ''
        }`}
      >
        <Description type='primary'>
          社会保険の登録方法に関するマニュアルは
          <span
            className='clickable-text'
            onClick={() => downloadCompanyInsuranceManual()}
            data-testid='company_insurance_manual_download_link'
          >
            こちら
          </span>
          からダウンロードできます。
        </Description>
      </div>
      <Information
        visible={visibleDownloadErrorDialog}
        title='ダウンロードエラー'
        message={messageUtility.getMessage('E-000-033')}
        buttonText={messageUtility.getMessage('I-000-017')}
        onClose={() => setVisibleDownloadErrorDialog(false)}
        buttonClassName='btn--sub'
      />
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/CompanyInsuranceManual.jsx